import { skipToken } from '@reduxjs/toolkit/dist/query';
import { Col, Row, Typography } from 'antd';
import { useFormikContext } from 'formik';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { SparingRequestPayload } from 'models/SparingRequests';
import { useParams } from 'react-router-dom';
import { useGetSparingRequestConfigurationTypesQuery } from 'redux/services/calvin/sparingRequestConfigTypes';
import { useGetSparingRequestQuery } from 'redux/services/twittlebugs/sparingRequestsApi';
import { useAppSelector } from 'redux/store';
import { InfoField } from './InfoField';

const styles: InlineStylesModel = {
  headerTitle: {
    fontWeight: 'bold',
    color: '#2F5596',
    whiteSpace: 'nowrap'
  }
};

export const DeploymentRequestInfo = (): JSX.Element => {
  const { values } = useFormikContext<SparingRequestPayload>();
  const { id } = useParams();

  // const { data } = useGetSparingRequestConfigurationTypeQuery(values.sparingRequestTypeId ?? skipToken);

  const { data: typesData, isLoading } = useGetSparingRequestConfigurationTypesQuery();
  const foundType = typesData?.data.find((type) => type.id === values.sparingRequestTypeId);
  const { data } = useGetSparingRequestQuery(id || skipToken);

  const { fullOutageAddress, fullShippingAddress } = useAppSelector((state) => state.form);

  const shippingAddress = fullShippingAddress
    ? `${fullShippingAddress.name}: ${fullShippingAddress.code}: ${fullShippingAddress.street1}, ${fullShippingAddress.city}, ${fullShippingAddress?.subdivisionLocalCode || ''}, ${
        fullShippingAddress.country || ''
      } ${fullShippingAddress.postalCode}`
    : '';

  const outageAddress = fullOutageAddress
    ? `${fullOutageAddress.name}: ${fullOutageAddress.code}: ${fullOutageAddress.street1}, ${fullOutageAddress.city}, ${fullOutageAddress?.subdivisionLocalCode || ''}, ${
        fullOutageAddress.country || ''
      } ${fullOutageAddress.postalCode}`
    : '';

  const findRequestNumber = (): string => {
    if (id && !values.requestNumber) return `${data?.requestNumber?.split('-')[0]}`;
    if (id) return `${data?.requestNumber?.split('-')[0]}--${values.requestNumber}`;
    if (!id && values.requestNumber) return `AUTOGENERATED--${values.requestNumber}`;

    return 'AUTOGENERATED';
  };

  const cartTotal = values.lineItems.reduce((acc, item) => item.quantity + acc, 0);

  return (
    <>
      <Row align="middle" gutter={[15, 15]} style={{ marginBottom: 10 }}>
        <Col>
          <InfoField>
            <Typography.Text style={styles.headerTitle}>Sparing Request Number: </Typography.Text>
            <Typography.Text>{findRequestNumber()}</Typography.Text>
          </InfoField>
        </Col>
        {values.customerReferenceNumber && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>{foundType?.reference1Label || 'Primary Reference Number'}: </Typography.Text>
              <Typography.Text>{values.customerReferenceNumber}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.customerPurchaseOrderNumber && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>{foundType?.reference2Label || 'Secondary Reference Number'}: </Typography.Text>
              <Typography.Text>{values.customerPurchaseOrderNumber}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.endCustomer && foundType?.isEndCustomerVisible && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>End Customer: </Typography.Text>
              <Typography.Text>{values.endCustomer}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.sparingRequestTypeId && foundType?.name && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>Spare Type: </Typography.Text>
              <Typography.Text>{foundType.name}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {!!values.lineItems.length && (
          <Col>
            <InfoField>
              <Typography.Text style={styles.headerTitle}>Items in Cart: </Typography.Text>
              <Typography.Text>{cartTotal}</Typography.Text>
            </InfoField>
          </Col>
        )}
        {/* </Space> */}
      </Row>
      <Row align="middle" gutter={[0, 8]} style={{ marginBottom: 8 }}>
        {values.outageLocationId && outageAddress && (
          <Col span={24} xxl={24}>
            <InfoField noWrap>
              <Typography.Text style={styles.headerTitle}>Outage Address: </Typography.Text>
              <Typography.Text ellipsis={{ tooltip: true }} style={{ textTransform: 'capitalize' }}>
                {outageAddress}
              </Typography.Text>
            </InfoField>
          </Col>
        )}
        {values.shippingLocationId && shippingAddress && (
          <Col span={24} xxl={24}>
            <InfoField noWrap>
              <Typography.Text style={styles.headerTitle}>Shipping Address: </Typography.Text>
              <Typography.Text ellipsis={{ tooltip: true }} style={{ textTransform: 'capitalize' }}>
                {shippingAddress}
              </Typography.Text>
            </InfoField>
          </Col>
        )}
      </Row>
    </>
  );
};
